export default "__VITE_ASSET__BiHkOsDX__"